import { useGSAP } from '@gsap/react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import React, { useRef } from 'react';
import PageBg from './PageBg';
gsap.registerPlugin(ScrollTrigger);

const GlobalAnimations = ({ children, initialBgColor }) => {
  const animContextRef = useRef();

  useGSAP(
    () => {
      let mm = gsap.matchMedia();

      // Hover
      const hoverEls = gsap.utils.toArray('.hoverScale');
      hoverEls.forEach((hoverEl) => {
        const angle = gsap.utils.random(-1, 1);
        const hover = gsap.to(hoverEl, {
          rotate: `${angle}deg `,
          scale: 1.02,
          duration: 0.5,
          ease: 'back.inOut(2)',
          paused: true,
        });

        hoverEl.addEventListener('mouseenter', () => hover.play(0));
        hoverEl.addEventListener('mouseleave', () => hover.reverse());
      });

      // Parallax
      // Runs only on tablet-landscape and up
      mm.add('(min-width: 900px)', () => {
        const scrollFastTriggers = gsap.utils.toArray(
          '.scrollFast, .scrollFastHero'
        );
        const scrollSlowTriggers = gsap.utils.toArray('.scrollSlow');
        scrollFastTriggers.forEach((trigger, index) => {
          const isHero = trigger.classList.contains('scrollFastHero');
          const scrollFastTween = gsap.fromTo(
            trigger,
            { yPercent: isHero ? 0 : 10 },
            {
              yPercent: -20,
              duration: 1,
              ease: 'none',
            }
          );
          ScrollTrigger.create({
            id: `scroll-fast-${index}`,
            trigger: trigger,
            start: isHero ? 'top top+=8%' : 'top bottom',
            end: isHero ? 'bottom top' : 'bottom top',
            animation: scrollFastTween,
            scrub: 1,
            // markers: true,
          });
        });
        scrollSlowTriggers.forEach((trigger, index) => {
          const scrollSlowTween = gsap.to(trigger, {
            yPercent: 40,
            duration: 1,
            ease: 'none',
          });
          ScrollTrigger.create({
            id: `scroll-slow-${index}`,
            trigger: trigger,
            start: 'top bottom',
            end: 'bottom top-=50%',
            animation: scrollSlowTween,
            scrub: 1,
            // markers: true,
          });
        });
      });

      // Fade In
      const scrollFadeInTriggers = gsap.utils.toArray('.scrollFadeIn');
      scrollFadeInTriggers.forEach((trigger, index) => {
        // Don't add an 'a' here, it causes conflicts
        const triggerChildren = gsap.utils.toArray(
          '.fadeInEl, h2, h3, h4, h5, li, p, .p',
          trigger
        );

        const scrollFadeInTween = gsap.from(triggerChildren, {
          opacity: 0,
          y: 60,
          // color: 'red',
          duration: 0.8,
          stagger: 0.02,
          ease: 'power2.out',
        });
        ScrollTrigger.create({
          id: `scroll-fade-in-${index}`,
          trigger: trigger,
          start: 'top 80%',
          end: 'bottom 80%',
          animation: scrollFadeInTween,
          toggleActions: 'play none none reverse',
          // scrub: 1,
          // markers: true,
          // onRefresh: (self) => {
          //   console.log(self.progress);
          //   self.progress > 0 && self.animation.progress(1);
          // },
        });
      });
    },
    { dependencies: [], scope: animContextRef }
  );

  return (
    <div ref={animContextRef}>
      <PageBg
        // bgContextRef={animContextRef} // trying to pass the ref to use as scope, but it doesn't really work
        colorTrigger={`.bgColorTrigger`}
        sizeTrigger={`.bgSizeTrigger`}
        initialColor={initialBgColor ? initialBgColor : 'Milk'}
        // markers
      />
      {children}
    </div>
  );
};

export default GlobalAnimations;
